<template>
    <div class="desert-container">
      <!-- Sol abrasador -->
      <div class="sun"></div>
      
      <!-- Dunas de arena -->
      <div class="dunes">
        <svg viewBox="0 0 1200 120" class="dunes-svg">
          <path d="M0,50 Q300,10 600,50 T1200,50 L1200,120 L0,120 Z" fill="#d97706" opacity="0.3" />
          <path d="M0,70 Q300,30 600,70 T1200,70 L1200,120 L0,120 Z" fill="#b45309" opacity="0.4" />
          <path d="M0,90 Q300,50 600,90 T1200,90 L1200,120 L0,120 Z" fill="#92400e" opacity="0.5" />
        </svg>
      </div>
  
      <!-- Palmeras decorativas -->
      <div class="palm-left">
        <svg width="100" height="140" viewBox="0 0 100 140">
          <!-- Tronco -->
          <rect x="42" y="60" width="16" height="80" fill="#8b4513" rx="3" />
          <ellipse cx="50" cy="75" rx="9" ry="4" fill="#654321" />
          <ellipse cx="50" cy="90" rx="9" ry="4" fill="#654321" />
          <ellipse cx="50" cy="105" rx="9" ry="4" fill="#654321" />
          <!-- Hojas -->
          <ellipse cx="30" cy="55" rx="35" ry="12" fill="#15803d" transform="rotate(-40 30 55)" />
          <ellipse cx="50" cy="45" rx="35" ry="12" fill="#16a34a" transform="rotate(-10 50 45)" />
          <ellipse cx="70" cy="55" rx="35" ry="12" fill="#15803d" transform="rotate(40 70 55)" />
          <ellipse cx="25" cy="65" rx="30" ry="10" fill="#166534" transform="rotate(-60 25 65)" />
          <ellipse cx="75" cy="65" rx="30" ry="10" fill="#166534" transform="rotate(60 75 65)" />
          <!-- Cocos -->
          <circle cx="48" cy="58" r="5" fill="#92400e" />
          <circle cx="55" cy="60" r="5" fill="#92400e" />
        </svg>
      </div>
  
      <div class="palm-right">
        <svg width="80" height="120" viewBox="0 0 80 120">
          <!-- Tronco -->
          <rect x="32" y="50" width="16" height="70" fill="#8b4513" rx="3" />
          <ellipse cx="40" cy="65" rx="9" ry="4" fill="#654321" />
          <ellipse cx="40" cy="80" rx="9" ry="4" fill="#654321" />
          <ellipse cx="40" cy="95" rx="9" ry="4" fill="#654321" />
          <!-- Hojas -->
          <ellipse cx="25" cy="45" rx="30" ry="10" fill="#15803d" transform="rotate(-35 25 45)" />
          <ellipse cx="40" cy="38" rx="30" ry="10" fill="#16a34a" transform="rotate(-5 40 38)" />
          <ellipse cx="55" cy="45" rx="30" ry="10" fill="#15803d" transform="rotate(35 55 45)" />
          <ellipse cx="20" cy="52" rx="25" ry="9" fill="#166534" transform="rotate(-55 20 52)" />
          <ellipse cx="60" cy="52" rx="25" ry="9" fill="#166534" transform="rotate(55 60 52)" />
          <!-- Cocos -->
          <circle cx="38" cy="48" r="4" fill="#92400e" />
          <circle cx="44" cy="50" r="4" fill="#92400e" />
        </svg>
      </div>
  
      <!-- Contenido principal -->
      <div class="content-center">
        <!-- Viajero perdido con animaciones mejoradas -->
        <div 
          class="traveler-container"
          :style="{ transform: `translate(${mousePos.x * 0.3}px, ${mousePos.y * 0.3}px)` }"
        >
          <!-- Efecto de calor -->
          <div class="heat-wave"></div>
  
          <!-- Viajero SVG mejorado -->
          <svg viewBox="0 0 200 220" class="traveler-svg">
            <!-- Sombra -->
            <ellipse cx="100" cy="210" rx="40" ry="8" fill="#000000" opacity="0.2" class="shadow-pulse" />
            
            <!-- Piernas con movimiento -->
            <g class="leg-walk">
              <rect x="85" y="150" width="12" height="40" fill="#8b4513" rx="6" />
              <rect x="103" y="150" width="12" height="40" fill="#8b4513" rx="6" />
            </g>
            
            <!-- Botas -->
            <rect x="82" y="185" width="18" height="15" fill="#654321" rx="3" />
            <rect x="100" y="185" width="18" height="15" fill="#654321" rx="3" />
            
            <!-- Túnica/ropa con detalles -->
            <path d="M 70,110 L 70,155 L 85,155 L 85,150 L 115,150 L 115,155 L 130,155 L 130,110 Z" fill="#d4a574" />
            <rect x="65" y="80" width="70" height="35" fill="#daa520" rx="5" />
            
            <!-- Detalles de la túnica -->
            <line x1="70" y1="85" x2="70" y2="110" stroke="#b8860b" stroke-width="2" />
            <line x1="130" y1="85" x2="130" y2="110" stroke="#b8860b" stroke-width="2" />
            
            <!-- Cinturón -->
            <rect x="65" y="108" width="70" height="8" fill="#8b4513" />
            <circle cx="100" cy="112" r="5" fill="#fbbf24" />
            <circle cx="85" cy="112" r="3" fill="#d97706" />
            <circle cx="115" cy="112" r="3" fill="#d97706" />
            
            <!-- Brazos con movimiento -->
            <g class="arm-swing-left">
              <rect x="50" y="85" width="15" height="50" fill="#d4a574" rx="7" />
              <circle cx="57" cy="135" r="8" fill="#c49a6c" />
            </g>
            <g class="arm-swing-right">
              <rect x="135" y="85" width="15" height="50" fill="#d4a574" rx="7" />
              <circle cx="142" cy="135" r="8" fill="#c49a6c" />
            </g>
            
            <!-- Mochila con detalles -->
            <rect x="110" y="85" width="25" height="30" fill="#8b4513" rx="5" />
            <rect x="115" y="90" width="15" height="20" fill="#654321" rx="3" />
            <line x1="118" y1="88" x2="125" y2="88" stroke="#d4a574" stroke-width="2" />
            <circle cx="122" cy="100" r="2" fill="#fbbf24" />
            
            <!-- Cantimplora -->
            <ellipse cx="55" cy="120" rx="8" ry="12" fill="#4b5563" />
            <rect x="53" y="110" width="4" height="8" fill="#6b7280" />
            <ellipse cx="55" cy="110" rx="3" ry="2" fill="#9ca3af" />
            
            <!-- Cuello -->
            <rect x="85" y="65" width="30" height="15" fill="#d4a574" rx="3" />
            
            <!-- Cabeza -->
            <circle cx="100" cy="50" r="22" fill="#d4a574" />
            
            <!-- Orejas -->
            <ellipse cx="78" cy="50" rx="4" ry="7" fill="#c49a6c" />
            <ellipse cx="122" cy="50" rx="4" ry="7" fill="#c49a6c" />
            
            <!-- Cara cansada con más expresión -->
            <circle cx="92" cy="48" r="3" fill="#654321" />
            <circle cx="108" cy="48" r="3" fill="#654321" />
            <line x1="88" y1="43" x2="95" y2="44" stroke="#654321" stroke-width="2" />
            <line x1="105" y1="44" x2="112" y2="43" stroke="#654321" stroke-width="2" />
            <path d="M 90,58 Q 100,55 110,58" stroke="#654321" stroke-width="2" fill="none" />
            <line x1="100" y1="53" x2="100" y2="56" stroke="#c49a6c" stroke-width="1.5" />
            
            <!-- Turbante elaborado -->
            <ellipse cx="100" cy="35" rx="28" ry="15" fill="#e8b86d" />
            <path d="M 72,35 Q 100,25 128,35" fill="#daa520" />
            <ellipse cx="100" cy="30" rx="26" ry="12" fill="#d4a574" />
            <circle cx="100" cy="28" r="7" fill="#fbbf24" />
            <circle cx="100" cy="28" r="4" fill="#dc2626" />
            <path d="M 105,25 Q 115,20 120,28" stroke="#b8860b" stroke-width="1.5" fill="none" />
          </svg>
  
          <!-- Gotas de sudor animadas -->
          <div class="sweat-drop sweat-1"></div>
          <div class="sweat-drop sweat-2"></div>
          <div class="sweat-drop sweat-3"></div>
        </div>
  
        <!-- Espejismo del oasis -->
        <div class="mirage">
          <div class="mirage-content">
            <svg width="40" height="40" viewBox="0 0 40 40" class="mirage-icon">
              <!-- Palmera -->
              <rect x="18" y="20" width="4" height="15" fill="#8b4513" />
              <path d="M 12,18 Q 20,10 28,18" fill="#22c55e" />
              <path d="M 10,22 Q 20,14 30,22" fill="#16a34a" />
              <!-- Agua -->
              <ellipse cx="20" cy="35" rx="15" ry="3" fill="#3b82f6" opacity="0.6" />
            </svg>
            <span class="mirage-text">¿Un oasis?</span>
          </div>
        </div>
  
        <!-- Texto 404 -->
        <h1 class="title-404">404</h1>
  
        <!-- Mensaje -->
        <h2 class="subtitle">¡Oasis no encontrado!</h2>
        <p class="description">
          Has vagado demasiado lejos en el desierto digital. Esta página es solo un espejismo que se desvanece bajo el sol.
        </p>
  
        <!-- Botón de regreso -->
        <button @click="goBack" class="back-button">
          <span class="button-content">
            <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Regresar al oasis real
          </span>
          <div class="button-overlay"></div>
        </button>
      </div>
  
      <!-- Pájaros en el cielo -->
      <div class="birds">
        <svg width="40" height="20" viewBox="0 0 40 20">
          <path d="M 5,10 Q 10,5 15,10" stroke="#78350f" stroke-width="2" fill="none" class="bird-fly" />
          <path d="M 15,10 Q 20,5 25,10" stroke="#78350f" stroke-width="2" fill="none" class="bird-fly" style="animation-delay: 0.2s" />
        </svg>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFound404',
    data() {
      return {
        mousePos: { x: 0, y: 0 }
      }
    },
    mounted() {
      window.addEventListener('mousemove', this.handleMouseMove);
    },
    beforeDestroy() {
      window.removeEventListener('mousemove', this.handleMouseMove);
    },
    methods: {
      handleMouseMove(e) {
        this.mousePos = {
          x: (e.clientX / window.innerWidth - 0.5) * 30,
          y: (e.clientY / window.innerHeight - 0.5) * 30
        };
      },
      goBack() {
        this.$router ? this.$router.go(-1) : window.history.back();
      }
    }
  }
  </script>
  
  <style scoped>
  .desert-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(to bottom, #fef3c7, #fde68a, #fcd34d);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .sun {
    position: absolute;
    top: 40px;
    right: 80px;
    width: 128px;
    height: 128px;
    border-radius: 50%;
    background: linear-gradient(135deg, #fef08a, #fbbf24, #f97316);
    filter: blur(40px);
    opacity: 0.6;
    animation: sun-pulse 4s ease-in-out infinite;
  }
  
  @keyframes sun-pulse {
    0%, 100% { opacity: 0.6; transform: scale(1); }
    50% { opacity: 0.8; transform: scale(1.1); }
  }
  
  .dunes {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 160px;
    opacity: 0.3;
  }
  
  .dunes-svg {
    width: 100%;
    height: 100%;
  }
  
  .palm-left {
    position: absolute;
    bottom: 80px;
    left: 40px;
    opacity: 0.5;
    animation: palm-sway 4s ease-in-out infinite;
    transform-origin: bottom center;
  }
  
  .palm-right {
    position: absolute;
    bottom: 120px;
    right: 60px;
    opacity: 0.4;
    animation: palm-sway 3.5s ease-in-out infinite;
    animation-delay: 0.5s;
    transform-origin: bottom center;
  }
  
  @keyframes palm-sway {
    0%, 100% { transform: rotate(-3deg); }
    50% { transform: rotate(3deg); }
  }
  
  .content-center {
    position: relative;
    z-index: 10;
    text-align: center;
    padding: 0 24px;
    max-width: 768px;
  }
  
  .traveler-container {
    position: relative;
    margin: 0 auto 32px;
    width: 288px;
    height: 288px;
    transition: transform 0.5s ease-out;
  }
  
  .heat-wave {
    position: absolute;
    inset: 0;
    opacity: 0.4;
    background: linear-gradient(to top, rgba(251, 146, 60, 0.4), transparent);
    filter: blur(20px);
    animation: heat-pulse 2s ease-in-out infinite;
  }
  
  @keyframes heat-pulse {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 0.5; }
  }
  
  .traveler-svg {
    width: 100%;
    height: 100%;
    animation: traveler-bounce 3s ease-in-out infinite;
  }
  
  @keyframes traveler-bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  
  .shadow-pulse {
    animation: shadow-pulse 3s ease-in-out infinite;
  }
  
  @keyframes shadow-pulse {
    0%, 100% { opacity: 0.2; transform: scale(1); }
    50% { opacity: 0.15; transform: scale(0.9); }
  }
  
  .leg-walk {
    animation: leg-walk 1s ease-in-out infinite;
    transform-origin: 94px 150px;
  }
  
  @keyframes leg-walk {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-2deg); }
    75% { transform: rotate(2deg); }
  }
  
  .arm-swing-left {
    animation: arm-swing 2s ease-in-out infinite;
    transform-origin: 57px 85px;
  }
  
  .arm-swing-right {
    animation: arm-swing 2s ease-in-out infinite reverse;
    transform-origin: 142px 85px;
  }
  
  @keyframes arm-swing {
    0%, 100% { transform: rotate(-15deg); }
    50% { transform: rotate(15deg); }
  }
  
  .sweat-drop {
    position: absolute;
    width: 8px;
    height: 12px;
    background: linear-gradient(to bottom, #60a5fa, #3b82f6);
    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
    opacity: 0.7;
    animation: sweat-fall 1.5s ease-in infinite;
  }
  
  .sweat-1 {
    top: 64px;
    left: 128px;
    animation-delay: 0s;
  }
  
  .sweat-2 {
    top: 80px;
    right: 136px;
    animation-delay: 0.5s;
  }
  
  .sweat-3 {
    top: 72px;
    left: 140px;
    animation-delay: 1s;
  }
  
  @keyframes sweat-fall {
    0% { transform: translateY(0) scale(1); opacity: 0.7; }
    100% { transform: translateY(30px) scale(0.5); opacity: 0; }
  }
  
  .mirage {
    margin-bottom: 32px;
    animation: mirage-pulse 3s ease-in-out infinite;
  }
  
  @keyframes mirage-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(0.95); }
  }
  
  .mirage-content {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    padding: 12px 24px;
    background: linear-gradient(to right, rgba(165, 243, 252, 0.4), rgba(147, 197, 253, 0.4));
    border-radius: 9999px;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(103, 232, 249, 0.3);
  }
  
  .mirage-icon {
    opacity: 0.6;
  }
  
  .mirage-text {
    color: #0891b2;
    font-weight: 500;
    opacity: 0.7;
    font-style: italic;
  }
  
  .title-404 {
    font-size: 9rem;
    font-weight: bold;
    background: linear-gradient(to right, #d97706, #b45309, #c2410c);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 16px;
    filter: drop-shadow(2px 2px 4px rgba(0,0,0,0.2));
    animation: title-shimmer 4s ease-in-out infinite;
  }
  
  @keyframes title-shimmer {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.85; }
  }
  
  .subtitle {
    font-size: 2.25rem;
    font-weight: bold;
    color: #78350f;
    margin-bottom: 16px;
  }
  
  .description {
    font-size: 1.25rem;
    color: #92400e;
    margin-bottom: 32px;
    max-width: 512px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .back-button {
    position: relative;
    padding: 16px 32px;
    background: linear-gradient(to right, #10b981, #0d9488);
    color: white;
    font-weight: 600;
    border-radius: 9999px;
    border: none;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .back-button:hover {
    transform: scale(1.05);
    box-shadow: 0 20px 50px rgba(16, 185, 129, 0.5);
  }
  
  .button-content {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .arrow-icon {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
  }
  
  .back-button:hover .arrow-icon {
    transform: translateX(-4px);
  }
  
  .button-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #0d9488, #10b981);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .back-button:hover .button-overlay {
    opacity: 1;
  }
  
  .birds {
    position: absolute;
    top: 128px;
    left: 33%;
    opacity: 0.4;
  }
  
  .bird-fly {
    animation: bird-fly 2s ease-in-out infinite;
  }
  
  @keyframes bird-fly {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }
  
  @media (max-width: 768px) {
    .title-404 {
      font-size: 6rem;
    }
    
    .subtitle {
      font-size: 1.875rem;
    }
    
    .description {
      font-size: 1.125rem;
    }
    
    .traveler-container {
      width: 240px;
      height: 240px;
    }
    
    .palm-left,
    .palm-right {
      transform: scale(0.8);
    }
  }
  </style>